import { configurationSettings } from '../../../../../configuration/configuration-settings';
import { LoyaltyAuthenticationType } from '../../../../../configuration/types/loyalty/loyalty-authentication-type';
import { updateIsMemberSignedInFromCookie } from './update-is-member-signed-in-from-cookie';
import { updateIsMemberSignedInFromToken } from './update-is-member-signed-in-from-token';
/**
 * Updates the `isMemberSignedIn` state based on the authentication type of the `loyalty.authentication`.
 */
export const updateIsMemberSignedIn = async (startInterval) => {
    switch (configurationSettings.data.loyalty.authentication.type) {
        case LoyaltyAuthenticationType.Cookie:
        case LoyaltyAuthenticationType.WorkstationCookie:
            return updateIsMemberSignedInFromCookie(startInterval);
        case LoyaltyAuthenticationType.Token:
        default:
            return await updateIsMemberSignedInFromToken();
    }
};
//# sourceMappingURL=update-is-member-signed-in.js.map